import { CommunityInfoData } from '../components/home/data/communityInfoTypes';
import localCommunityData from '../components/home/data/awmCommunityInfoData.json';

import { GOOGLE_API_KEY } from './constants';

export const fetchCommunityInfoData = async (
  fileId: string
): Promise<CommunityInfoData> => {
  if (!GOOGLE_API_KEY) {
    console.warn(
      '🔑 Google API key not found, using local community info data'
    );
    return localCommunityData as CommunityInfoData;
  }

  try {
    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media&key=${GOOGLE_API_KEY}`,
      {
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId); // Clear timeout if request completes

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('📊 Successfully loaded community info data from Google Drive');
    return data as CommunityInfoData;
  } catch (error) {
    console.warn(
      '⚠️ Error fetching community info data from Drive, using local data:',
      error
    );
    return localCommunityData as CommunityInfoData;
  }
};
